import Cesium from 'cesium';

function createSingleTileImageLayer(name) {
  const provider = new Cesium.SingleTileImageryProvider({
    url: `${process.env.PUBLIC_URL}/${name}.jpg`,
  });
  return new Cesium.ImageryLayer(provider, {
    brightness: 0.7,
  });
}

export default createSingleTileImageLayer;



// WEBPACK FOOTER //
// ./src/core/createSingleTileImageLayer.js